import React from "react";
import { Callout, CalloutType } from "@sscs/ui";
import styles from "./dialogWarning.module.scss";

type Status = Extract<CalloutType, "warning" | "error" | "info">;

type DialogWarningProps = {
  status: Status;
  title: string;
  byline: string;
};

/**
 * An Callout carrying the spacing it needs inside a Dialog.Content.
 * The banner itself — border, tint, icon and title colour — belongs entirely to
 * the design-system component; this only owns the gap from the content above.
 */
const DialogWarning = ({
  status,
  title,
  byline,
}: DialogWarningProps): React.JSX.Element => (
  <Callout className={styles["dialog-warning"]} type={status} title={title}>
    {byline}
  </Callout>
);

export default DialogWarning;
